// extracted by mini-css-extract-plugin
module.exports = {"UseCase":"UseCase_UseCase__2zAWf"};